import React from 'react'

import { Grid, Typography } from '@material-ui/core'

import {
  BoxWrap,
  Card,
  ContainerSlide,
  LeftPartGrid,
  OtherProductImage,
  ProductImage,
  RightPartContentBox,
  RightPartGrid,
  RightPartTitle,
} from 'artkive/components/OurProductsNavMenu/OurProductsNavMenu.style'
import { NAVIGATION } from 'artkive/constants/tracker/mainNavigation'
import routes from 'artkive/utils/routes'

import Books from 'images/ecom/megamenu/Books.jpg'
import Cardkive from 'images/ecom/megamenu/Cardkive.jpg'
import Mosaics from 'images/ecom/megamenu/Mosaics.jpg'
import Photokive from 'images/ecom/megamenu/Photokive.jpg'

import { TrackLink } from '../Tracker'

const OurProductsNavMenu = ({ isOpen, setIsOpen }) => {
  return (
    <ContainerSlide
      in={isOpen}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      timeout={300}
    >
      <BoxWrap>
        <Grid container>
          <LeftPartGrid item>
            <Grid container alignItems='center' justifyContent='center'>
              <Grid item>
                <Card
                  href={routes.books}
                  component={TrackLink}
                  trackerEvent={NAVIGATION.ART_BOOK_CLICK}
                  trackerOptions={{ section: 'navigation_menu' }}
                >
                  <ProductImage src={Books} />
                  <Typography variant='h6'>Kids Art Books</Typography>
                </Card>
              </Grid>
              <Grid item>
                <Card
                  component={TrackLink}
                  href={routes.mosaics}
                  trackerEvent={NAVIGATION.MOSAIC_CLICK}
                  trackerOptions={{ section: 'navigation_menu' }}
                >
                  <ProductImage src={Mosaics} />
                  <Typography variant='h6'>Framed Mosaics</Typography>
                </Card>
              </Grid>
            </Grid>
          </LeftPartGrid>
          <RightPartGrid item>
            <RightPartContentBox>
              <RightPartTitle variant='h6'>More from the Kive Co.</RightPartTitle>
              <Grid container alignItems='center' justifyContent='center'>
                <Grid item>
                  <Card
                    component={TrackLink}
                    href={routes.cardkive}
                    trackerEvent={NAVIGATION.CARDS_CLICK}
                    trackerOptions={{ section: 'navigation_menu' }}
                  >
                    <OtherProductImage src={Cardkive} alt='Cardkive Product Preview' />
                    <Typography variant='h6'>Cardkive</Typography>
                  </Card>
                </Grid>
                <Grid item>
                  <Card
                    component={TrackLink}
                    href={routes.photokive}
                    trackerEvent={NAVIGATION.PHOTOKIVE_CLICK}
                    trackerOptions={{ section: 'navigation_menu' }}
                  >
                    <OtherProductImage src={Photokive} alt='Photokive Product Preview' />
                    <Typography variant='h6'>Photokive</Typography>
                  </Card>
                </Grid>
              </Grid>
            </RightPartContentBox>
          </RightPartGrid>
        </Grid>
      </BoxWrap>
    </ContainerSlide>
  )
}

export default OurProductsNavMenu
